import firebase from 'firebase/compat/app';

const app = firebase.initializeApp({
    apiKey: "AIzaSyCNE8SJYzakUaNSm9elNo8d0Bah-OOlRns",
    authDomain: "squaddisk.firebaseapp.com",
    databaseURL: "https://squaddisk-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "squaddisk",
    storageBucket: "squaddisk.appspot.com",
    messagingSenderId: "799671045959",
    appId: "1:799671045959:web:a3479b189870060f4d8662"
});

export default firebase;
